module.exports = __webpack_public_path__ + "static/media/sect_indicator.2691fd56.svg";